export default __webpack_public_path__ + "media/src/assets/images/sign-54a541260a7cf004be14bf8ef0d6f365.png";